import { Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      {/* Cambuilder Live Model — footer leaderboard (desktop only) */}
      <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', mb: 2, mt: 3 }}>
        <iframe
          src="https://as.sexad.net/as/if?p=reseller&w=1&h=1&v=9933&adHeight=90&adWidth=970&adType=live&autoplay=false&showvideo=false&hn=instacamgirls.net&AFNO=1-ICGcom"
          allowTransparency={true}
          width="970"
          height="90"
          style={{ maxWidth: '100%', border: 'none', display: 'block' }}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          scrolling="no"
          title="Live Models Footer"
        />
      </Box>

      {/* Cambuilder Live Model — mobile banner */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mb: 2, mt: 2 }}>
        <iframe
          src="https://as.sexad.net/as/if?p=reseller&w=1&h=1&v=9933&adHeight=90&adWidth=320&adType=live&autoplay=false&showvideo=false&hn=instacamgirls.net&AFNO=1-ICGcom"
          allowTransparency={true}
          width="320"
          height="90"
          style={{ maxWidth: '100%', border: 'none', display: 'block' }}
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          scrolling="no"
          title="Live Models Footer Mobile"
        />
      </Box>
      <Typography sx={{ fontSize: "12px", paddingTop: "15px"}}>
        <Link to="/terms" style={{ color: "inherit", textDecoration: "none" }}>Terms of Service</Link>
        {" · "}
        <Link to="/privacy" style={{ color: "inherit", textDecoration: "none" }}>Privacy Policy</Link>
        {" · "}
        <a href="mailto:legal@instacamgirls.com" style={{ color: "inherit", textDecoration: "none" }}>DMCA</a>
        {" · "}
        <span style={{ color: "#999" }}>18 U.S.C. 2257</span>
      </Typography>
      <Typography sx={{ marginTop: 2, fontSize: "12px" }}>
        This website is not affiliated with Instagram or endorsed by and does not claim to represent or own any of the trademarks, trade names or rights associated with any of the products which are the property of their respective owners who do not own, endorse, or promote this website.
      </Typography>
    </footer>
  );
};

export default Footer;
